import React from 'react';
import { Package } from 'lucide-react';

const RecentOrderCard = ({ order, onViewDetails }) => {
  const { orderNumber, status, totalAmount, createdAt, items = [] } = order;

  const getStatusClass = (statusName) => {
    switch (statusName) {
      case 'Pending': return 'pending';
      case 'Confirmed': return 'confirmed';
      case 'Packed': return 'packed';
      case 'Shipped': return 'shipped';
      case 'Delivered': return 'delivered';
      case 'Cancelled': return 'cancelled';
      default: return 'pending';
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const day = date.getDate();
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const itemsCount = items ? items.reduce((sum, item) => sum + item.qty, 0) : 0;

  return (
    <div 
      className="recent-item-row" 
      onClick={() => onViewDetails && onViewDetails(order)} 
      style={{ cursor: 'pointer' }}
    >
      <div className="recent-item-left-col">
        <div className="recent-item-icon-box">
          <Package size={20} />
        </div>
        <div className="recent-item-info">
          <span className="recent-item-title">
            {orderNumber || `Order #${order._id.substring(18)}`}
          </span>
          <span className="recent-item-subtitle">
            {formatDate(createdAt)} • {itemsCount} {itemsCount === 1 ? 'Item' : 'Items'}
          </span>
        </div>
      </div>

      <div className="recent-item-center-right">
        <div className="recent-item-col order-status-col">
          <span className={`status-badge ${getStatusClass(status)}`}>
            {status}
          </span>
        </div>

        <div className="recent-item-col order-amount-col">
          <span className="recent-item-amount">
            ₹{totalAmount ? totalAmount.toLocaleString('en-IN') : 0}
          </span>
        </div>
      </div>

      <div className="recent-item-col order-action-col">
        {onViewDetails && (
          <button 
            onClick={(e) => {
              e.stopPropagation();
              onViewDetails(order);
            }} 
            className="btn-view-details"
          >
            View Details
          </button>
        )}
      </div>

      <div className="recent-item-mobile-arrow">
        <span>→</span>
      </div>
    </div>
  );
};

export default RecentOrderCard;
